module.exports = __webpack_public_path__ + "media/images/icons/twotone/camera-c12c5da0ec85fb0e1e757b507ed5f3a0.svg";